module.exports = __webpack_public_path__ + "38182acbe124317b2c1495cd66fc2704.svg";